import { BusySystem } from "event-definitions"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { warningSnackbar } from "lib/snackbar/warning-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"

const BATCH_SIZE = 25

export async function runBulk(ids, { progress, past, item = "schedule" }, run) {
    const total = ids.length
    const failed = []
    let done = 0
    updateProgressBar()
    try {
        for (let i = 0; i < total; i += BATCH_SIZE) {
            const batch = ids.slice(i, i + BATCH_SIZE)
            failed.push(...((await run(batch)) ?? []))
            done += batch.length
            updateProgressBar()
        }
    } finally {
        BusySystem.raise({ running: false })
    }

    const succeeded = total - failed.length
    if (failed.length === 0) {
        if (succeeded > 0) successSnackbar(`${past} ${succeeded} ${item.pluralize(succeeded)}`)
    } else if (succeeded > 0) {
        warningSnackbar(
            `Not all ${item.pluralize(total)} were ${past.toLowerCase()} — ${failed.length} of ${total} couldn't be ${past.toLowerCase()}`
        )
    } else {
        errorSnackbar(`${failed.length} ${item.pluralize(failed.length)} couldn't be ${past.toLowerCase()}`)
    }
    return { succeeded, failed }

    function updateProgressBar() {
        BusySystem.raise({
            running: true,
            message: `${progress} ${done} of ${total}`,
            progress: total ? Math.round((done / total) * 100) : 100,
        })
    }
}
